module.exports = __webpack_public_path__ + "img/hong-9.939837a5.png";